import { FC, Fragment } from 'react';
import pluralize from 'pluralize';

import { Hint, HintProps } from './Hint';

type HintListProps = Omit<HintProps, 'tooltip'> & {
  items: string[];
  itemType: string;
};

export const HintList: FC<HintListProps> = ({ icon, items, itemType, soft, warning }) =>
  items.length > 0 ? (
    <Hint
      icon={icon}
      soft={soft}
      tooltip={
        items.length === 1 ? (
          <Fragment>
            <strong>{pluralize.singular(itemType)}: </strong>
            {items.at(0)}
          </Fragment>
        ) : (
          <Fragment>
            <strong>{pluralize.plural(itemType)}:</strong>
            <ul>
              {items.map(item => (
                <li key={item}>{item}</li>
              ))}
            </ul>
          </Fragment>
        )
      }
      warning={warning}
    />
  ) : null;
